import Vue from 'vue'
import Router from 'vue-router'
import routerConfig from './config'
// import { mapGetters } from 'vuex'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: routerConfig.routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.roles)) {
    if (localStorage.getItem('role') === null) {
      next({
        path: '/account'
      })
    }
    let role = parseInt(localStorage.getItem('role'))
    if (to.meta.roles.indexOf(role) === -1) {
      next({
        path: '/account'
      })
    }
    next()
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js